import React from 'react';
import PropTypes from 'prop-types';
import { FaDownload } from 'react-icons/fa';

import MessageDecorate from './MessageDecorate';
import styles from './FileMessage.scss';

FileMessage.propTypes = {
    ...MessageDecorate.propTypes,
    mediaUrl: PropTypes.string.isRequired,
};

export default function FileMessage({ mediaUrl, ...rest }) {
    const filename = extractFilename(mediaUrl);

    return (
        <MessageDecorate {...rest}>
            <a className={styles.link} href={mediaUrl} target="__blank">
                <FaDownload className={styles.icon} />
                {' ' + filename}
            </a>
        </MessageDecorate>
    );
}

function extractFilename(url) {
    if (!url) return 'Broken file url';

    const re = /\/([^/?#]+)([?#].*)?$/;
    const match = url.match(re);

    try {
        if (match) return decodeURIComponent(match[1]);
    } catch (err) {
        if (err instanceof URIError) {
            return match[1];
        }
        throw err;
    }

    return url;
}
